export default "__VITE_ASSET__42dd237b__"